module.exports = __webpack_public_path__ + "img/question.149e60e2.svg";